import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faLock, faExclamationTriangle, faHeart, faBolt } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, OverlayTrigger } from "react-bootstrap";

class FlagFormatter extends React.Component {
	renderFlags() {
		if (this.props.value) {
			const red = "#ba1111";
			const yellow = "#dec02c";
			const blue = "#3250ad";
			const purple = "#ab1f77";
			const lightBlue = "#00a4fc"

			var m = new Map();
			m.set('PDN', { icon: faFlag, color: red });
			m.set('MDC', { icon: faFlag, color: yellow });
			m.set('OPC', { icon: faFlag, color: "default" });
			m.set('DDV', { icon: faFlag, color: blue });
			m.set('PWP', { icon: faLock, color: "default" });
			m.set('MDD', { icon: faExclamationTriangle, color: red });
			m.set('EXP', { icon: faBolt, color: blue });
			m.set('MED', { icon: faHeart, color: purple });
			m.set('OWU', { icon: faFlag, color: "default" });
			m.set('APL', { icon: faFlag, color: lightBlue });

			var tooltip = [];
			this.props.value.map((v, index) =>
				tooltip[index] = (
					<Tooltip style={{maxWidth:'200px'}} id={"tooltip" + index}>
						{/* Strip HTML from comment */}
						{v.comment.replace(/(<([^>]+)>)/ig, "")}
					</Tooltip>
				)
			);

			return this.props.value.map((v, index) =>
				<React.Fragment key={"flag" + index}>
					&nbsp;
					<OverlayTrigger placement={this.props.value.length === 1 ? "right" : index%2 ? "top" : "bottom"} overlay={tooltip[index]}>
						<FontAwesomeIcon 
							style={{ marginTop:"0"}} 
							id={"icon" + index} 
							color={m.get(v.statusCode).color} 
							icon={m.get(v.statusCode).icon} 
							size="sm" />
					</OverlayTrigger>
					&nbsp;
				</React.Fragment>
			);
		}
		else {
			return null;
		}
	}

	render() {
		return (<div style={{textAlign: "center", padding: 0}}> {this.renderFlags()} </div>);
	}
}

export default FlagFormatter;



// WEBPACK FOOTER //
// ./src/areas/admin/shared/FlagFormatter.js